export default __webpack_public_path__ + "static/media/logoNoBg.34089237.svg";